// @flow
import type {Element} from 'react'
import React from 'react'
import classnames from 'classnames'

type Props = {|
  sm?: boolean,
  lg?: boolean,
  white?: boolean,
|}

function LoadingDots({sm, lg, white}: Props): Element<"div"> {
  const loadingDotsClass = classnames('loading-dots', {
    small: sm,
    large: lg,
    white,
  })

  const dots = Array.from({length: 12}, (_, i) => (
    <div key={`loading-dots-${i}`} className="dot" />
  ))

  return (
    <div className={loadingDotsClass} test-id="loading-dots">
      {dots}
    </div>
  )
}

LoadingDots.defaultProps = {
  sm: false,
  lg: false,
  white: false,
}

export default LoadingDots
